import { SpaceColumnField, SpaceRouteName, SpaceSortType, SpaceType } from './enums';
export const SPACE_LABEL_ALL = 'all';
/**
 * 空间路由名称与空间类型的映射
 */
export const ROUTE_NAME_SPACES_TYPE_MAP = {
    [SpaceRouteName.Personal]: SpaceType.Personal,
    [SpaceRouteName.Shared]: SpaceType.Shared,
    [SpaceRouteName.Public]: SpaceType.Public,
};
/**
 * 空间排序列表
 */
export const SPACE_SORT_LIST = [
    SpaceSortType.CreateTimeAsc,
    SpaceSortType.CreateTimeDesc,
    SpaceSortType.UpdateTimeDesc,
    SpaceSortType.AccessTimeDesc,
    SpaceSortType.Name,
];
/**
 * 空间列表默认展示字段
 */
export const SPACE_LIST_DEFAULT_COLUMNS = [
    SpaceColumnField.SpaceName,
    SpaceColumnField.UserRole,
    SpaceColumnField.UpdateTime,
    SpaceColumnField.FolderCount,
    SpaceColumnField.Actions,
];
/**
 * 空间列表展示字段
 */
export const SPACE_LIST_CONFIGURABLE_COLUMNS = [
    SpaceColumnField.UserRole,
    SpaceColumnField.UpdatedUser,
    SpaceColumnField.FolderCount,
    SpaceColumnField.CreateTime,
    SpaceColumnField.Creator,
    SpaceColumnField.PatentCount,
    SpaceColumnField.PaperCount,
    SpaceColumnField.BioCount,
    SpaceColumnField.DrugCount,
    SpaceColumnField.ClinicalCount,
    SpaceColumnField.InvestmentCount,
    SpaceColumnField.MarketCount,
    SpaceColumnField.MergerCount,
];
/**
 * 邀请协助有效期之永久
 */
export const FOREVER_TS = 9999999999999;
/**
 * 空间名称最大长度
 */
export const MAX_SPACE_NAME_LENGTH = 80;
/**
 * 文件夹名称最大长度
 */
export const MAX_FOLDER_NAME_LENGTH = 40;
